import { Box, Pressable, useTheme } from "@kolmeo/ui-core";
import { Card, Icon } from "@kolmeo/ui-components";
import { useTranslation } from "react-i18next";
import RowItem, { RowItemButtonProps } from "../RowItem";
import { TenancyPaymentDetails } from "@src/navigation/TenancyNavigator/types";
import Clipboard from "@react-native-clipboard/clipboard";
import { PaymentMethod } from "@src/types";
import { Tooltip } from "@src/components/Hover/Tooltip/Tooltip";
import { usePaymentMethodLabel } from "@src/screens/Tenant/hooks/usePaymentMethodLabel";
import { View } from "react-native";

type VirtualAccountMethodContentCardType = {
  item?: TenancyPaymentDetails;
  propertyName?: string;
};

const VirtualAccountMethodContentCard = ({ item, propertyName }: VirtualAccountMethodContentCardType) => {
  const { palette, colors } = useTheme();
  const { t } = useTranslation(["Common", "Tenant"]);
  const onCopyField = (text?: string) => {
    text && Clipboard.setString(text);
  };

  const paymentMethodLabel = usePaymentMethodLabel(PaymentMethod.virtualAccount);

  const displayAccountName = (item as any)?.accountName?.toString().trim() || propertyName?.toString().trim() || paymentMethodLabel;

  return (
    <Card
      flexDirection="row"
      marginBottom={1}
      marginHorizontal={1}
      renderShadow
      flex={1}
      borderColor={colors.primary}
      borderWidth={0.4}
      position="relative"
    >
      {/* <Box mb="auto" backgroundColor="green" width="100%"> */}
      <Box flexDirection="row" width="100%" flexWrap="wrap" paddingBottom={3}>
        <Box flexDirection="column" flex={3}>
          <RowItem alignment="right" label={<Icon type="bank" size="lg" color={palette.text.secondary} />} />
          <View style={{ flexDirection: "row", flex: 1 }}>
            <View style={{ flexDirection: "row", flex: 1 }}>
              <RowItem label={`${t("Tenant:PaymentMethods.AccountName")}: ${displayAccountName}`} shorten={false} />
              <View style={{ marginTop: 2, marginLeft: 5 }}>
                <Tooltip title={"If your bank doesn’t allow the full account name, enter as much as you can and shorten if needed."}>
                  <Icon type={"information"} size={16} color={palette.text.secondary} />
                </Tooltip>
              </View>
            </View>
            <View>
              <Box alignItems={"flex-end"} justifyContent={"center"} mr={1}>
                <Pressable
                  onPress={() => {
                    onCopyField(displayAccountName);
                  }}
                >
                  <Icon type={"copy"} size={12} color={palette.text.secondary} />
                </Pressable>
              </Box>
            </View>
          </View>
          <RowItem
            label={`${t("Tenant:PaymentMethods.BSB")}: ${item?.bsbNumber}`}
            buttonRight={
              { icon: "copy", onPress: () => onCopyField(item?.bsbNumber), size: 12, color: palette.text.secondary } as RowItemButtonProps
            }
          />
          <RowItem
            label={`${t("Tenant:PaymentMethods.Account")}: ${item?.accountNumber}`}
            buttonRight={
              {
                icon: "copy",
                onPress: () => onCopyField(item?.accountNumber),
                size: 12,
                color: palette.text.secondary
              } as RowItemButtonProps
            }
          />
        </Box>
      </Box>
    </Card>
  );
};

export default VirtualAccountMethodContentCard;
